import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import { getHome } from '../api/catalog'
import type { HomeResponse } from '../api/types'
import Loading from '../components/Loading'

export default function HomePage() {
  const [data, setData] = useState<HomeResponse | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    getHome()
      .then(setData)
      .catch((err: Error) => setError(err.message))
  }, [])

  if (error) return <p className="error">{error}</p>
  if (!data) return <Loading />

  return (
    <div>
      <Helmet>
        <title>{data.page.seo.title ?? data.page.title ?? 'Helmach'}</title>
        {data.page.seo.description && (
          <meta name="description" content={data.page.seo.description} />
        )}
      </Helmet>

      {data.sliders.length > 0 && (
        <section className="hero">
          {data.sliders.map((slider) => (
            <div key={slider.id} className="hero-slide">
              <img src={slider.image} alt={slider.title ?? ''} />
              <div className="hero-overlay">
                <div className="hero-content">
                  {slider.title && <h1>{slider.title}</h1>}
                  {slider.excerpt && <p>{slider.excerpt}</p>}
                  <Link to="/urunlerimiz" className="btn btn-primary">
                    Ürünleri İncele
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </section>
      )}

      <section className="section">
        <div className="container">
          <div className="section-heading">
            <h2>Öne Çıkan Ürünler</h2>
            <p>Araç bakımı ve kimyasal çözümlerde geniş ürün yelpazemiz.</p>
          </div>
          <div className="product-grid">
            {data.products.map((product) => (
              <Link key={product.id} to={`/urunlerimiz/${product.slug}`} className="product-card">
                <img src={product.image} alt={product.title ?? ''} />
                <h3>{product.title}</h3>
              </Link>
            ))}
          </div>
          <div className="section-cta">
            <Link to="/urunlerimiz" className="btn btn-outline">
              Tüm Ürünleri Gör
            </Link>
          </div>
        </div>
      </section>

      {data.about.title && (
        <section className="section section-alt">
          <div className="container about-teaser">
            {data.about.image && <img src={data.about.image} alt={data.about.title ?? ''} />}
            <div>
              <h2>{data.about.title}</h2>
              {data.about.content && (
                <div dangerouslySetInnerHTML={{ __html: data.about.content }} />
              )}
              <Link to="/hakkimizda" className="btn btn-outline">
                Devamını Oku
              </Link>
            </div>
          </div>
        </section>
      )}
    </div>
  )
}
